import requestAction from '../../utils/requestAction'

export const fetchPreorderAllProducts = (params: string = "") => {
  return requestAction('PREORDER_ALL_PRODUCT_LIST')(params ? `preorderAllProducts/${params}` : `preorderAllProducts`, 'GET')
}
